import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { SectionVM, EnteDichiaranteList } from 'civil-status/view-models/step-form';
import { ID_ALTRO_STATO } from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerEnteDichiarante = (
  valuesSection?: Array<SectionVM>
): Array<EnteDichiaranteList> | undefined => {
  if ((valuesSection || []).length === 0) {
    return undefined;
  }

  return valuesSection?.map((itemSection) => {
    const isOtherState = itemSection?.foreign?.state?.code === ID_ALTRO_STATO;
    const isOtherMunicipality =
      itemSection?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

    return {
      key: itemSection?.idEnteDichiarante
        ? {
            idEnteDichiarante: itemSection?.idEnteDichiarante,
          }
        : undefined,
      dataTrascrizione: itemSection?.documentDateFormation
        ? itemSection.documentDateFormation.toFormat('yyyy-MM-dd')
        : itemSection.dateTranscription
        ? itemSection.dateTranscription.toFormat('yyyy-MM-dd')
        : undefined,
      estremiDocumento: itemSection?.documentExtremes || undefined,
      nomeEnteDichiarante:
        itemSection?.nameInstitution || itemSection?.nameInstituteAbandonedMinor || undefined,
      idComune: itemSection?.italian?.municipality?.code?.toString()
        ? itemSection?.italian?.municipality?.code
        : undefined,
      nomeComune: isOtherMunicipality
        ? itemSection.italian?.otherMunicipality || undefined
        : itemSection?.italian?.municipality?.description,
      idProvincia: itemSection?.italian?.municipality?.idProvince || undefined,
      siglaProvincia: itemSection?.italian?.municipality?.province || undefined,
      idNazione:
        itemSection.isForeign || itemSection.foreign?.state?.code
          ? itemSection.foreign?.state?.code
            ? Number.parseInt(itemSection.foreign?.state?.code, 10)
            : undefined
          : itemSection?.italian?.municipality?.description &&
            itemSection.configuration !== ConfigurationType.CSRA
          ? ID_ITALIAN_NATION
          : undefined,
      nomeNazione:
        itemSection.isForeign || itemSection.foreign?.state?.value
          ? isOtherState
            ? itemSection.foreign?.otherState || undefined
            : itemSection.foreign?.state?.value
          : itemSection?.italian?.municipality?.description &&
            itemSection.configuration !== ConfigurationType.CSRA
          ? DESCRIPTION_ITALIAN_NATION
          : undefined,
      nomeComuneEstero: itemSection.foreign?.locationForeign || undefined,
      anagraficaConsolato: itemSection.foreign?.consulate?.id?.toString() || undefined,
      nomeAnagraficaConsolato: itemSection.foreign?.consulate?.value || undefined,
      trascrizione: itemSection.documentDescription || undefined,
      ruolo: itemSection.rolo || undefined,
      indirizzo: itemSection.address || undefined,
      sezione: itemSection?.codeSection || undefined,
      tipoPersistenza: itemSection?.typePersistence || undefined,
      tipoSezione: itemSection?.typeSection || undefined,
      codiceSezione: itemSection?.codeSection || undefined,
      configurazione: itemSection?.configuration || undefined,
    };
  });
};
